// extracted by mini-css-extract-plugin
export var container = "_4j-0";
export var icon = "_4j-1";
export var text = "_4j-2";